/* eslint-disable @typescript-eslint/naming-convention */

let allowedNextLocalesAndIsoLocales;
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  ({ allowedNextLocalesAndIsoLocales } = require("@simplyk/common"));
} catch {
  allowedNextLocalesAndIsoLocales = [
    "fr",
    "en",
    "es",
    "de",
    "fr-CA",
    "en-CA",
    "en-US",
    "es-US",
    "en-GB",
    "en-AU",
    "en-IE",
    "de-DE",
    "en-DE",
  ];
}

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    returnNull: false,
    locales: allowedNextLocalesAndIsoLocales,
    defaultLocale: "en",
    localeDetection: true,
    fallbackLng: {
      "fr-CA": ["fr"],
      "en-CA": ["en"],
      "en-US": ["en"],
      "en-GB": ["en"],
      "en-AU": ["en"],
      "en-IE": ["en"],
      "de-DE": ["de", "en"],
      "en-DE": ["en"],
      "es-US": ["es"],
    },
  },
  localePath: "./public/locales",
};
